import { useSearchParams } from "react-router";
import { CargarMas, TablaRegistros, useAuditoriaDelDia } from "@/features/auditoria";
import { t } from "@/shared/i18n";
import { hoyEnChile } from "@/shared/lib/fechas";
import { useAhora } from "@/shared/lib/reloj";
import { Campo, EncabezadoPagina, Herramientas, Tarjeta } from "@/shared/ui";
import { SegunConsulta, useCorreoDe, useTitulo } from "./comun";
import estilos from "./Paginas.module.css";

const a = t.auditoria;
const DIA = /^\d{4}-\d{2}-\d{2}$/;

export function Auditoria() {
  const ahora = useAhora();
  const hoy = hoyEnChile(ahora);
  const [parametros, setParametros] = useSearchParams();
  const crudo = parametros.get("dia") ?? "";
  const dia = DIA.test(crudo) && crudo <= hoy ? crudo : hoy;
  const consulta = useAuditoriaDelDia(dia);
  const correoDe = useCorreoDe();
  useTitulo(a.titulo);

  return (
    <div className={estilos.pila}>
      <EncabezadoPagina titulo={a.titulo} subtitulo={a.subtitulo} />
      <div>
        <Herramientas>
          <Campo
            className={estilos.dia}
            rotulo={a.dia}
            type="date"
            max={hoy}
            value={dia}
            onChange={(e) => {
              const v = e.target.value;
              if (!DIA.test(v)) return;
              setParametros(v === hoy ? {} : { dia: v }, { replace: true, preventScrollReset: true });
            }}
          />
        </Herramientas>
        <Tarjeta>
          <SegunConsulta consulta={consulta}>
            {() => (
              <>
                <TablaRegistros
                  registros={consulta.data?.pages.flatMap((p) => p.registros) ?? []}
                  correoDe={correoDe}
                  soloHora
                  vacio={a.vacio}
                />
                <CargarMas
                  hayMas={consulta.hasNextPage}
                  cargando={consulta.isFetchingNextPage}
                  alCargar={() => void consulta.fetchNextPage()}
                />
              </>
            )}
          </SegunConsulta>
        </Tarjeta>
      </div>
    </div>
  );
}
